export const DEFAULT_TEXT_SIZE = 'text-sm';
export const MAX_ARTICLE_WIDTH = 'max-w-2xl';
export const MAX_TEXT_POST_WIDTH = 'sm:max-w-lg';

export const MOTION_DURATION_SECONDS = {
  fast: 0.1,
  base: 0.2,
  medium: 0.3,
  slow: 0.4
} as const;

export const MOTION_EASING = {
  enter: [0, 0, 0.2, 1],
  exit: [0.4, 0, 1, 1],
  move: [0.4, 0, 0.2, 1],
  panel: [0.32, 0.72, 0, 1]
} satisfies Record<string, [number, number, number, number]>;
